interface Props {
  size?: number;
  color?: string;
}

const BellIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M10.959.421q-.09-.04-.174-.087h-.409c-.6.216-.815.664-.776 1.276.012.177.01.354.006.528l-.003.228-.138.02c-.1.015-.19.028-.28.045q-.195.039-.385.094c-1.43.417-2.633 1.176-3.547 2.37-.943 1.232-1.464 2.608-1.438 4.176.008.49.006.982.003 1.473l-.002.737c.001.703-.046 1.402-.216 2.087-.19.771-.479 1.505-.974 2.13-.352.443-.742.857-1.132 1.27l-.098.105c-.394.418-.577.884-.483 1.467.13.802.814 1.442 1.675 1.442l8.79-.001h7.035c.163 0 .327-.007.486-.035.733-.128 1.366-.78 1.39-1.587.018-.564-.203-1.022-.632-1.4a6.66 6.66 0 0 1-1.844-2.622 6 6 0 0 1-.426-2.025c-.01-.488-.006-.976 0-1.464.004-.484.008-.967-.002-1.45a8.3 8.3 0 0 0-.152-1.535 6.6 6.6 0 0 0-1.283-2.74 6.9 6.9 0 0 0-2.202-1.851 6.7 6.7 0 0 0-2.031-.683c-.154-.026-.16-.096-.16-.21l.004-.222c.004-.223.009-.446-.01-.666-.014-.17-.083-.339-.15-.498-.085-.204-.264-.288-.442-.372m-1.2 23.15q.15.046.298.096h.955q.18-.057.36-.107c.264-.074.527-.148.771-.263 1.078-.509 1.736-1.368 2.007-2.541H7.017c.307 1.19.96 2.093 2.102 2.59.207.09.423.157.64.225"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default BellIcon;
